import clsx from 'clsx';

const TITLE_CLASS = {
  lg: 'type-section-title-lg',
  xl: 'type-section-title-xl',
  default: 'type-section-title',
  sm: 'type-section-title-sm',
};

/**
 * SectionHeading — homepage header pattern (Outcomes / Capabilities).
 * Geist extrabold navy + optional Instrument Serif brand-blue accent.
 */
export function SectionHeading({
  eyebrow,
  kickerTitle,
  kickerAccent,
  title,
  titleAccent,
  titleLine2,
  accentBlock = false,
  kickerAccentBlock = false,
  size = 'default',
  align = 'left',
  className = '',
  titleClassName = '',
  headingId,
}) {
  const titleCls = TITLE_CLASS[size] || TITLE_CLASS.default;
  const center = align === 'center';
  const hasKicker = kickerTitle != null || kickerAccent != null;

  return (
    <header
      className={className}
      style={{ textAlign: center ? 'center' : 'left' }}
    >
      {eyebrow && <span className="lb-eyebrow">{eyebrow}</span>}
      {(title != null || hasKicker) && (
        <h2
          id={headingId}
          className={clsx(titleCls, titleClassName)}
          style={center ? { marginLeft: 'auto', marginRight: 'auto', maxWidth: 860 } : undefined}
        >
          {hasKicker && (
            <>
              {kickerTitle}
              {kickerAccent != null && (
                <>
                  {' '}
                  <span
                    className={clsx(
                      'serif-accent',
                      'type-section-accent',
                      kickerAccentBlock && 'type-section-accent-block',
                    )}
                  >
                    {kickerAccent}
                  </span>
                </>
              )}
              {title != null && <br />}
            </>
          )}
          {title}
          {titleAccent != null && (
            <>
              {' '}
              <span
                className={clsx(
                  'serif-accent',
                  'type-section-accent',
                  accentBlock && 'type-section-accent-block',
                )}
              >
                {titleAccent}
              </span>
            </>
          )}
          {titleLine2 != null && (
            <>
              <br />
              {titleLine2}
            </>
          )}
        </h2>
      )}
    </header>
  );
}
